export interface SalesReportToolbarProps {}

const SalesReportToolbar: React.FC<SalesReportToolbarProps> = ({}) => {
  return null;
};
export default SalesReportToolbar;
